const OurTeam = () => {
  return (
    <div className="our-team" id="nas-tim">
      <div className="our-team-all-page">
        <div className="our-team-title">Naš tim</div>
        <div className="our-team-text">
          Kompaniju čini kvalifikovan tim stručnjaka iz oblasti bezbednosti koji
          deli strast prema stvaranju bezbednijeg društva i stoji vam na
          raspolaganju za sva dodatna pitanja i informacije:
        </div>
        <div className="our-team-members">
          <div className="our-team-member">
            <img
              src={`/images/direktor1.jpg`}
              alt="triotim"
              className="our-team-img"
            />
            <div className="our-team-text-img">
              Jelena Stamenković, master menadžer bezbednosti
            </div>
            <div className="our-team-text-img">Tel: 063/1641-853</div>
            <div className="our-team-text-img">Email: jelena.s@triotim.rs</div>
          </div>

          <div className="our-team-member">
            <img
              src={`/images/direktor2.jpg`}
              alt="triotim"
              className="our-team-img"
            />
            <div className="our-team-text-img">
              Tamara Jorgić, diplomirani menadžer bezbednosti
            </div>
            <div className="our-team-text-img">Tel: 061/1326-103</div>
            <div className="our-team-text-img">Email: tamara.j@triotim.rs</div>
          </div>
          <div className="our-team-member">
            <img
              src={`/images/direktor3.jpg`}
              alt="triotim"
              className="our-team-img"
            />
            <div className="our-team-text-img">
              Milica Đinović, diplomirani menadžer bezbednosti
            </div>
            <div className="our-team-text-img">Tel: 061/2379-368</div>
            <div className="our-team-text-img">Email: milica.d@triotim.rs</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurTeam;
